module.exports = require("./VersionIconNameDisplay.vue");